import { ApiRequest } from "../api/Api";
import { usePaymentsStore } from "../store/PaymentsStore";

export const usePayment = () => {
	const { ListUpdate } = usePaymentsStore();

	const CollectHandler = async (
		addressList: string[],
		wallet: string,
		type: "usdt" | "coin"
	) => {
		const address = addressList;
		switch (address[0].substring(0, 2)) {
			default:
				return await ApiRequest("/main/collect", {
					address,
					wallet,
					coinsType: type === "usdt" ? "trc20" : "trx",
				});
			case "0x":
				return await ApiRequest("/main/collect", {
					address,
					wallet,
					coinsType: type === "usdt" ? "erc20" : "eth",
				});
		}
	};

	const GetPaymentsList = async (network: string) => {
		const list = await ApiRequest("/main/payments", { network });
		if (!list?.data) {
			return;
		}
		switch (network) {
			case "tron":
				ListUpdate("tronList", list?.data);
				break;
			case "ethereum":
				ListUpdate("ethereumList", list?.data);
				break;
		}
	};

	return { CollectHandler, GetPaymentsList };
};
